import React, { FC, useMemo } from 'react'
import styles from 'styles/components/form.module.scss'
import text from 'styles/utility/text.module.scss'
import { Spacer } from 'components/Utility'
import { SelectBox } from 'components/Form'
import { SelectOption } from 'types/common'
import { useTimesWithRange } from 'hooks/store'
import { parseDateToDeadline, parseTimeToDeadline } from 'lib/helper'

type Props = {
  hoursToDeadline: number
  selectDateToDeadline: (value: string) => void
  selectTimeToDeadline: (value: string) => void
}

const HoursToDeliveryDeadlineForm: FC<Props> = (props) => {
  const { hoursToDeadline, selectDateToDeadline, selectTimeToDeadline } = props

  const dateToDeadline = parseDateToDeadline(hoursToDeadline)
  const timeToDeadline = parseTimeToDeadline(hoursToDeadline)

  const dateToDeadlineOptions = useMemo(() => {
    const options: SelectOption[] = [{ label: `当日`, value: '0' }]
    for (let i = 1; i < 31; i = (i + 1) | 0) {
      options.push({ label: `${i}日前`, value: String(i) })
    }
    return options
  }, [])
  // 15分毎で24時間分のリストを作る
  const timeToDeadlineOptions = useTimesWithRange('00:00', hoursToDeadline === 0 ? '00:00' : '23:45')

  return (
    <div>
      <div className={styles.column_two}>
        <div className={`${styles.column_two__item} ${text.font_small}`}>締め切り日</div>
        <Spacer size={8} />
        <div className={`${styles.column_two__item} ${text.font_small}`}>締め切り時間</div>
      </div>
      <Spacer size={8} />
      <div className={styles.column_two}>
        <div className={styles.column_two__item}>
          <SelectBox options={dateToDeadlineOptions} select={selectDateToDeadline} value={dateToDeadline} />
        </div>
        <Spacer size={8} />
        <div className={styles.column_two__item}>
          <SelectBox options={timeToDeadlineOptions} select={selectTimeToDeadline} value={timeToDeadline} />
        </div>
      </div>
    </div>
  )
}

export default HoursToDeliveryDeadlineForm
